import { ChangeEvent } from 'react';
import styled from 'styled-components';
import FormLabel from '../atoms/FormLabel';
import Selecter from '../atoms/Selecter';
import space from '../utils/style/space';
import color from '../utils/style/color';
import InputContainer from '../atoms/InputContainer';

type Props = {
  label?: string;
  value: string;
  onChangeLocation: (event: ChangeEvent<HTMLSelectElement>) => void;
  errorMessage?: string;
  locationList: { value: string; label: string }[];
};

const ErrorMessage = styled.p`
  margin-top: ${space.xxxs}px;
  color: ${color.red.error};
`;

const LocationSelecter = styled(Selecter)`
  width: 100%;
  background-position: 62px center;
`;

const SelectForm = ({
  label,
  value,
  onChangeLocation,
  errorMessage,
  locationList
}: Props) => {
  return (
    <InputContainer>
      {label && <FormLabel>{label}</FormLabel>}
      <LocationSelecter
        value={value}
        options={locationList}
        title="Location"
        onChange={onChangeLocation}
      />
      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </InputContainer>
  );
};

SelectForm.defaultProps = {
  disabled: false
};

export default SelectForm;
